// extracted by mini-css-extract-plugin
export default {"wrapper":"Payments_wrapper__wdYiS","blocksWrapper":"Payments_blocksWrapper__I+xqt","header":"Payments_header__P35UV"};